export default "__VITE_ASSET__BeJK6w6J__"